import supportLocale from '../constants/supportLocale';

export const isValidLang = (t) => {
  return supportLocale.some(({locale, disable}) => locale == t && !disable);
};
export const isValidDisabledLang = (t) => {
  return supportLocale.some(({locale, disable}) => locale == t && !!disable);
};

export const getUserLang = (langInCookie, acceptLang) => {
  if (langInCookie && isValidLang(langInCookie)) return langInCookie;
  
  acceptLang = typeof acceptLang == 'string' 
    && acceptLang.split(';')[0].split(',')[0].toLowerCase() 
    || '';
  if (acceptLang.startsWith('zh')) {
    acceptLang = /^zh-(tw|hk|mo|hant)(-|$)/.test(acceptLang)
      ? 'zh-hant' 
      : 'zh-hans'
  } else {
    acceptLang = acceptLang.substring(0, 2);
  }
  if (isValidLang(acceptLang)) return acceptLang;
  // return en as default
  return 'en'; 
}

export const getLangDir = (lang) => {
  return (supportLocale.find(({locale}) => locale == lang) || {})['dir'] || 'ltr';
}